export default __webpack_public_path__ + "static/media/Success1.d0c05095.png";